import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/business";

export default function FloatingCall() {
  return (
    <a
      href={`tel:${BUSINESS.phoneRaw}`}
      className="lg:hidden fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-5 py-3.5 rounded-full shadow-2xl shadow-red-950/40 pulse-ring"
      data-testid="floating-call-button"
    >
      <Phone className="h-5 w-5" /> Call Now
    </a>
  );
}
